module.exports = __webpack_public_path__ + "img/empty-1.d950a6f1.svg";